<ng-container *ngIf="form !== null">
  <div class="cf-dlg">

    <!-- HEADER -->
    <div class="cf-dlg-header">
      <div class="cf-dlg-icon"><mat-icon>vpn_key</mat-icon></div>
      <div>
        <h2 class="cf-dlg-title">Configurar acceso</h2>
        <p class="cf-dlg-subtitle">{{ empleado?.name }}</p>
      </div>
    </div>

    <!-- BODY -->
    <div class="cf-dlg-body">
      <p class="ca-note">
        Al guardar los datos de acceso, se activará el usuario de forma automática.
      </p>

      <form [formGroup]="form">
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Correo electrónico</mat-label>
          <input type="email" matInput formControlName="email">
          <mat-error *ngIf="form.controls['email'].hasError('required')">
            El correo electrónico es <strong>obligatorio</strong>
          </mat-error>
          <mat-error *ngIf="form.controls['email'].hasError('email')">
            Introduce un correo electrónico <strong>válido</strong>
          </mat-error>
        </mat-form-field>

        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Contraseña</mat-label>
          <input [type]="hidePassword ? 'password' : 'text'" matInput formControlName="password">
          <button mat-icon-button matSuffix (click)="togglePasswordVisibility()" type="button"
            [attr.aria-label]="hidePassword ? 'Mostrar contraseña' : 'Ocultar contraseña'">
            <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
          <mat-error *ngIf="form.controls['password'].hasError('required')">
            La contraseña es <strong>obligatoria</strong>
          </mat-error>
          <mat-error *ngIf="form.controls['password'].hasError('minlength')">
            Mínimo 6 caracteres
          </mat-error>
        </mat-form-field>
      </form>
    </div>

    <!-- FOOTER -->
    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="cancel()">Cancelar</button>
      <button mat-flat-button class="cf-dlg-btn-primary" (click)="onSubmit()">
        <mat-icon>save</mat-icon> Guardar
      </button>
    </div>

  </div>
</ng-container>
